import React from 'react';
import Modal from '../../../BaseComponents/Modal';
import Button from '../../../BaseComponents/Button';
import { PanelWithDetails } from '../../../../api/panels';
import './PanelModal.scss';
import trash from "../../../../assets/icons/TrashBin2.svg";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  panel: PanelWithDetails | null;
  onEdit?: (panel: PanelWithDetails) => void;
  onDelete?: (panelId: number) => void;
};

const ViewPanelModal: React.FC<Props> = ({ isOpen, onClose, panel, onEdit, onDelete }) => {
  if (!panel) return null;

  const handleEdit = () => {
    if (onEdit) {
      onEdit(panel);
      onClose();
    }
  };

  const handleDelete = () => {
    if (onDelete) {
      onDelete(panel.id);
    }
  };

  const formatPrice = (price: number | null | undefined): string => {
    if (price === null || price === undefined) return 'No price set';
    return `${price.toFixed(2)}`;
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      title="Panel"
      width="800px"
    >
      <div className="panel-view-modal">
        <div className="panel-details">
          <div className="detail-field">
            <label className="field-label">Name of the panel</label>
            <div className="field-value">{panel.name}</div>
          </div>

          <div className="detail-field">
            <label className="field-label">Catalog ID</label>
            <div className="field-value">
              {panel.catalog_id || 'No catalog ID assigned'}
            </div>
          </div>

          <div className="detail-field">
            <label className="field-label">Body system(s)</label>
            <div className="field-value">
              {panel.body_systems && panel.body_systems.length > 0 
                ? panel.body_systems.map(bs => bs.title).join(', ')
                : 'No body systems assigned'
              }
            </div>
          </div>

          <div className="detail-field">
            <label className="field-label">Associated biomarkers</label>
            <div className="field-value">
              {panel.biomarkers && panel.biomarkers.length > 0 
                ? panel.biomarkers.map(bm => bm.name).join(', ')
                : 'No biomarkers associated'
              }
            </div>
          </div>

          <div className="detail-field">
            <label className="field-label">Price</label>
            <div className="field-value">
              {formatPrice(panel.price)}
            </div>
          </div>

           <div className="detail-field">
            <label className="field-label">Non Discounted Price</label>
            <div className="field-value">
              {formatPrice(panel.non_discounted_price ?? panel.non_discounted_price)}
            </div>
          </div>
        </div>

        <div className="modal-actions">
          <Button
            text="Edit"
            onClick={handleEdit}
            isSecondary={false}
          />
          <button 
            className="delete-button"
            onClick={handleDelete}
          >
            <img src={trash} alt="delete" />
            Delete panel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ViewPanelModal;

